// extracted by mini-css-extract-plugin
export default {"container":"hZAJw05W","grid":"iNRZ7cLO","ordersBlock":"AFHStPlW","routesBlock":"G97ZlE4w","mapBlock":"u4kUX615","requestsBlock":"UgmZmsvr","blockPlaceholder":"GyDsAvH8"};